import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type MapNodeType = Node<NodeData, 'custom_map'>;

export const MapNode: React.FC<NodeProps<MapNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const targetBlockType = data.config?.target_block_type as string;
  const maxConcurrency = data.config?.max_concurrency as number;

  let subtitle: string | undefined;
  if (targetBlockType) {
    const concurrencyText = maxConcurrency ? ` (${maxConcurrency}x)` : '';
    subtitle = `Map: ${targetBlockType}${concurrencyText}`;
  }

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="flow"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Input handle for array with connection indicators */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="array"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'array'))
            : undefined
        }
      />
      {/* Output handle for results */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="result"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
